import { WRAPPER_TYPES } from '../../../constants';
import { forwardRef } from 'react';
import { Scrollbar } from 'react-scrollbars-custom';
import { compilationScrollbarSettings } from '../../../../../../constants/copyright';

const wrappers = {
  [WRAPPER_TYPES.default]: ({ children }) => <>{children}</>,
  [WRAPPER_TYPES.scroll]: forwardRef(({ children, onScroll }, ref) => (
    <Scrollbar ref={ref} {...compilationScrollbarSettings} onScroll={onScroll}>
      {children}
    </Scrollbar>
  )),
};

const ModalWrapper = forwardRef(function ({ prizes, children, ...rest }, ref) {
  const type = !!prizes?.length ? WRAPPER_TYPES.scroll : WRAPPER_TYPES.default;
  const Wrapper = wrappers[type];
  return <Wrapper {...arguments[0]} ref={ref} />;
});

export default ModalWrapper;
